import { HostCapabilityMap } from 'adaptivecards';

export default function registerHostCapabilities(hostCapabilities: HostCapabilityMap) {
    hostCapabilities['Transaction'] = '*';
    hostCapabilities['Transaction.MSA'] = '*';
}
